import React, { useEffect, useState } from "react";
import { LeftSide } from "./LeftSide";
import { Middle } from "./Middle";
import { RightSide } from "./RightSide";
import { FaDribbble, FaFigma, FaLinkedin, FaTwitter } from "react-icons/fa";

export const Footer = () => {
  const [hideNav, setHideNav] = useState(false);
  const currentYear = new Date().getFullYear()
  useEffect(() => {
    if (
      window.location.pathname === "/Pages/Registration" ||
      window.location.pathname === "/Pages/Reset" || window.location.pathname === "/Pages/CreateNewPassword"
    ) {
      setHideNav(true);
    } else {
      setHideNav(false);
    }
  }, []);
  return (
    <div className={hideNav ? "hidden" : "block py-4"}>
      <hr className="border-gray-200 dark:border-[#3d3d3d]" />
      <div className="px-7 grid md:grid-cols-2 xl:grid-cols-3 md:gap-12">
        <LeftSide />
        <div className="hidden md:block lg:hidden">
          <RightSide />
        </div>
        <div className="">

        <Middle />
        </div>
        <div className="md:hidden lg:block">
          <RightSide />
        </div>
      </div>
      <div className="text-center opacity-60 text-sm mt-4">
        <p>© {currentYear} PremiumUIKits. All rights reserved</p>
      </div>
    </div>
  );
};
